// Навигационные хелперы - вынесены из router.js для избежания циклических импортов
// ВАЖНО: этот файл НЕ должен импортировать router.js
import {computed} from 'vue';
import {ROUTES} from '@/router/routes.js';

// Создаём отдельный экземпляр роутера для навигации
let _routerInstance = null;

export function setRouter(router) {
    _routerInstance = router;
}

export function useNavigation() {
    if (!_routerInstance) {
        console.warn('[navigation] Router not initialized yet');
    }
    
    return {
        routes: ROUTES,
        navigateTo: (to, params = {}, query = {}) => {
            if (!_routerInstance) {
                console.error('[navigation] Router not initialized. Cannot navigate to:', to);
                return Promise.reject(new Error('Router not initialized'));
            }
            
            const routeObj = typeof to === 'string'
                ? {name: to, params, query}
                : {...to, params, query};

            return _routerInstance.push(routeObj).catch(err => {
                if (!err.message.includes('NavigationDuplicated')) {
                    console.error('Navigation error:', err);
                    throw err;
                }
            });
        },
        getRoutePath: (routeName, params = {}) => {
            if (!_routerInstance) return '';
            const route = _routerInstance.resolve({name: routeName, params});
            return route.path;
        },
        getRouteParams: (routeName, params = {}) => {
            if (!_routerInstance) return {};
            const route = _routerInstance.resolve({name: routeName, params});
            return route.params;
        },
        isActiveRoute: (routeName) => {
            if (!_routerInstance) return computed(() => false);
            return computed(() => _routerInstance.currentRoute.value.name === routeName);
        },
        updateQuery: (query) => {
            if (!_routerInstance) return Promise.resolve();
            return _routerInstance.replace({query: {..._routerInstance.currentRoute.value.query, ...query}});
        },
        updatePushQuery: (query) => {
            if (!_routerInstance) return Promise.resolve();
            return _routerInstance.push({query: {..._routerInstance.currentRoute.value.query, ...query}});
        },
        currentRoute: computed(() => _routerInstance?.currentRoute.value || null)
    };
}
